import { Card, Statistic, Skeleton } from 'antd'
import type { ReactNode } from 'react'

interface KpiWidgetProps {
  title: string
  value: number | null | undefined
  loading?: boolean
  color?: string
  prefix?: ReactNode
  onClick?: () => void
}

export function KpiWidget({ title, value, loading, color, prefix, onClick }: KpiWidgetProps) {
  return (
    <Card
      size="small"
      style={{ cursor: onClick ? 'pointer' : undefined, minWidth: 160 }}
      onClick={onClick}
    >
      {loading ? (
        <Skeleton active paragraph={false} />
      ) : (
        <Statistic
          title={title}
          value={value ?? 0}
          valueStyle={{ color: color ?? '#1677ff' }}
          prefix={prefix}
        />
      )}
    </Card>
  )
}
